import { settingsCopy } from '@/copy'

// Provider types offered in the create-provider dropdown.
export const PROVIDER_TYPES = [
  { value: 'anthropic', label: 'Anthropic' },
  { value: 'gemini', label: 'Google Gemini' },
  { value: 'openai', label: 'OpenAI-compatible' },
  { value: 'deepseek', label: 'DeepSeek' },
  { value: 'glm_coding', label: 'GLM (Z.ai Coding Plan)' },
  { value: 'glm', label: 'GLM (Z.ai)' },
] as const

// Default base URLs per provider type. Module-private — only `baseUrlPlaceholder`
// consults this. Mirrors `default_openai_compat_base` / `openai_version_prefix`
// in crates/runtime/src/config.rs: the backend derives the version prefix from
// the base URL (/v1 for OpenAI/DeepSeek and z.ai's /api/openai surface; none
// for z.ai surfaces that already carry a version like /api/paas/v4). So these
// defaults must NOT include a /v1 suffix.
const PROVIDER_DEFAULT_BASE_URL: Record<string, string> = {
  anthropic: 'https://api.anthropic.com',
  // Native Gemini API; the backend appends /v1beta unless the URL carries a version.
  gemini: 'https://generativelanguage.googleapis.com',
  openai: 'https://api.openai.com',
  deepseek: 'https://api.deepseek.com',
  // Coding-plan keys authenticate here (documented OpenAI-compat surface).
  glm_coding: 'https://api.z.ai/api/coding/paas/v4',
  // General pay-as-you-go API; rejects coding-plan keys.
  glm: 'https://api.z.ai/api/paas/v4',
}

/** Placeholder for the Base URL field given the selected provider type. */
export function baseUrlPlaceholder(providerType: string): string {
  // Generic OpenAI-compatible endpoints have no sensible default — require one.
  if (providerType === 'openai') {
    return settingsCopy.providers.baseUrlExample('https://api.openai.com/v1')
  }
  const def = PROVIDER_DEFAULT_BASE_URL[providerType]
  return def
    ? settingsCopy.providers.baseUrlDefault(def)
    : settingsCopy.providers.baseUrlOptional
}
